import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { ErrorEstandarDTO } from './ErrorEstandarDTO';
export type HandleError = <T>(
  operation?: string,
  result?: T
) => (error: HttpErrorResponse) => Observable<T>;

@Injectable()
export class HttpErrorHandler {
  iDTOError: ErrorEstandarDTO;

  constructor() {}

  createHandleError = (serviceName = '') => <T>(
    operation = 'operation',
    result = {} as T
  ) => this.handleError(serviceName, operation, result);

  /**
   * Returns a function that handles Http operation failures.
   * This error handler lets the app continue to run as if no error occurred.
   * @param serviceName = name of the data service that attempted the operation
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  handleError<T>(serviceName = '', operation = 'operation', result = {} as T) {
    this.iDTOError = new ErrorEstandarDTO('', 'Desconocido', 'Desconocido', '');

    return (error: HttpErrorResponse): Observable<T> => {
      let message: string;

      try {
        this.iDTOError.s_Codigo = error.error.s_Codigo;
        this.iDTOError.s_Descripcion = error.error.s_Descripcion;
        this.iDTOError.s_Tipo = error.error.s_Tipo;
        this.iDTOError.s_Severidad = error.error.s_Severidad;

        if (this.iDTOError.s_Descripcion.indexOf('|') > 0)
          this.iDTOError.s_Descripcion = this.iDTOError.s_Descripcion.substr(
            0,
            this.iDTOError.s_Descripcion.indexOf('|')
          );
      } catch {
        this.iDTOError.s_Tipo = error.status.toString();
        this.iDTOError.s_Descripcion = error.message;

        if (error.error instanceof ErrorEvent) {
          this.iDTOError.s_Descripcion = error.error.message;

          if (error.error.error != null)
            this.iDTOError.s_Severidad = error.error.error;
        }
      }
      message = this.iDTOError.s_Codigo + ': ' + this.iDTOError.s_Descripcion;
      console.error(error); // log to console instead
      console.error(message); // log to console instead
      return of(result);
    };
  }
}

/*
Copyright 2017-2018 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/
